import { render, staticRenderFns } from "./lossWeightCognitivebehaviorald.vue?vue&type=template&id=2a5bb4d2&scoped=true&"
import script from "./lossWeightCognitivebehaviorald.vue?vue&type=script&lang=js&"
export * from "./lossWeightCognitivebehaviorald.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightCognitivebehaviorald.vue?vue&type=style&index=0&id=2a5bb4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bb4d2",
  null
  
)

export default component.exports